
import { defineComponent, onBeforeMount, reactive, PropType } from 'vue'

// @components
import NewModal from '@/common/new-components/NewModal/index.vue'
import NewSelect from '@/ui-kit/NewSelect/index.vue'

// @types
import { Sector } from '@/new-services/types/sectors'
import { ContainerPayload } from '@/new-services/types/planning'

// @new-services
import sectorsAPI from '@/new-services/sectors.service'

// @validation
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

// @composable
import useNotifications from '@/common/composable/useNotifications'

const CARGO_TYPES = [
    { id: 1, name: 'МГГ' },
    { id: 2, name: 'КГГ' },
]

export default defineComponent({
    components: {
        NewModal,
        NewSelect,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        dispatcherSectorIds: {
            type: Array as PropType<number[]>,
            required: true,
            default: () => [],
        },
        waveId: {
            type: Number,
            required: true,
        },
        date: {
            type: String,
            required: true,
        },
    },
    emits: ['submit', 'cancel'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            sectorId: null as number | null,
            cargoType: null as number | null,
        })

        const data_state = reactive({
            sectors: {
                is_loading: false,
                is_failed: false,
                list: [] as Sector[],
            },
        })

        const loadSectors = async () => {
            try {
                data_state.sectors.is_loading = true

                const response = await sectorsAPI.getSectors({
                    page: 1,
                    limit: 9999,
                    dispatcherSectorIds: props.dispatcherSectorIds,
                })

                data_state.sectors.list = response.data.data

                data_state.sectors.is_failed = false
            } catch (error) {
                data_state.sectors.is_failed = true
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При получении секторов произошла ошибка',
                })
            } finally {
                data_state.sectors.is_loading = false
            }
        }

        const state_form$ = useVuelidate(
            {
                sectorId: { required },
                cargoType: { required },
            },
            state
        )

        const onCancel = () => {
            if (props.loading) return
            emit('cancel')
        }

        const onSubmit = () => {
            if (props.loading) return

            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            const payload: ContainerPayload = {
                waveId: props.waveId,
                sectorId: state.sectorId as number,
                date: props.date,
                cargoType: state.cargoType as number,
            }

            emit('submit', payload)
        }

        onBeforeMount(loadSectors)

        return {
            CARGO_TYPES,
            state,
            state_form$,
            data_state,
            onCancel,
            onSubmit,
            loadSectors,
        }
    },
})
